<template>
  <div class="header-bar">
    <sider-trigger :collapsed="collapsed" icon="md-menu" @on-change="handleCollpasedChange"></sider-trigger>
    <header-menu  class="header-menu" style="margin-left: 40px;"  @on-select="turnToPage"></header-menu>
<!--    <custom-bread-crumb show-icon style="margin-left: 30px;" :list="breadCrumbList"></custom-bread-crumb>-->
    <emblem></emblem>
    <div class="custom-content-con">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import siderTrigger from './sider-trigger'
import customBreadCrumb from './custom-bread-crumb'
import headerMenu from './header-menu'
import emblem from './title/title.vue'
import './header-bar.less'

import './header-bar.less'
export default {
  name: 'HeaderBar',
  components: {
    siderTrigger,
    headerMenu,
    customBreadCrumb,
    emblem,
  },
  props: {
    collapsed: Boolean
  },
  computed: {
    breadCrumbList () {
      return this.$store.state.app.breadCrumbList
    }
  },
  methods: {
    handleCollpasedChange (state) {
      this.$emit('on-coll-change', state)
    },
    turnToPage (item,val) {
      this.$emit('on-select', item,val)
    }
  }
}
</script>
